import * as Yup from 'yup'

export function getValidation(stepName) {
    const validationSchemas = {
        billing: Yup.object({
            billingMethod: Yup.mixed()
                .required("Billing method is required")
                .test("has-value", "Billing method is required", function(value) {
                    if (!value || typeof value !== "object") return false
                    return value.value && value.value !== ""
                }),
            bank: Yup.mixed()
                .when('billingMethod', {
                    is: (val) => val?.value === 'BILLING' || val?.value === 'REIMBURSEMENT',
                    then: () => Yup.mixed()
                        .required("Please enter routing number and choose bank from the dropdown list")
                        .test("has-routing-number", "Routing number must be 9 digits", function(value) {
                            if (!value) return false
                            // Check if it's an object with routingNumber
                            if (typeof value === "object" && value.routingNumber) {
                                const routingNumber = String(value.routingNumber).replace(/\D/g, "")
                                if (routingNumber.length === 0) return false
                                return routingNumber.length === 9
                            }
                            // If it's a string, check if it's a valid routing number
                            if (typeof value === "string") {
                                const routingNumber = value.replace(/\D/g, "")
                                if (routingNumber.length === 0) return false
                                return routingNumber.length === 9
                            }
                            return false
                        }),
                    otherwise: () => Yup.mixed().nullable(),
                }),
            bankName: Yup.string()
                .when('billingMethod', {
                    is: (val) => val?.value === 'BILLING' || val?.value === 'REIMBURSEMENT',
                    then: () => Yup.string().nullable(),
                    otherwise: () => Yup.string().nullable(),
                }),
            nickname: Yup.string()
                .when('billingMethod', {
                    is: (val) => val?.value === 'BILLING',
                    then: () => Yup.string()
                        .required("Nickname is required")
                        .trim()
                        .min(1, "Nickname is required"),
                    otherwise: () => Yup.string().nullable(),
                }),
            accountType: Yup.string()
                .when('billingMethod', {
                    is: (val) => val?.value === 'BILLING',
                    then: () => Yup.string()
                        .required("Account type is required")
                        .oneOf(["checking", "savings"], "Account type must be checking or savings"),
                    otherwise: () => Yup.string().nullable(),
                }),
            accountNumber: Yup.string()
                .when('billingMethod', {
                    is: (val) => val?.value === 'BILLING',
                    then: () => Yup.string()
                        .required("Account number is required")
                        .test("is-valid-length", "Account number must be between 4 and 17 digits", function(value) {
                            if (!value) return false
                            const digits = String(value).replace(/\D/g, "")
                            return digits.length >= 4 && digits.length <= 17
                        }),
                    otherwise: () => Yup.string().nullable(),
                }),
        }),
    }
    
    const normalizedStepName = typeof stepName === "string"
        ? stepName.trim().toLowerCase().replace(/\s+/g, "_").replace(/-/g, "_")
        : undefined
    
    const validationSchema = validationSchemas[normalizedStepName] || Yup.object({})
    
    // console.log("Billing getValidation:", {
    //     stepName,
    //     normalizedStepName,
    //     hasSchema: !!validationSchemas[normalizedStepName],
    //     schemaKeys: Object.keys(validationSchemas)
    // })
    
    return {
        validationSchema
    }
}

// Add this default export
export default getValidation